"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Explore = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M11.994 15.752a3.75 3.75 0 1 0 .001-7.498 3.75 3.75 0 0 0-.001 7.498Zm3.262-.309a1.119 1.119 0 0 0 0 1.583l2.902 2.902a1.12 1.12 0 0 0 1.583 0l.043-.044a1.12 1.12 0 0 0 0-1.583L16.883 15.4a1.119 1.119 0 0 0-1.583 0l-.044.044Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M15.256 15.443a1.119 1.119 0 0 0 0 1.583l2.901 2.902a1.12 1.12 0 0 0 1.583 0l.044-.044a1.12 1.12 0 0 0 0-1.583L16.883 15.4a1.12 1.12 0 0 0-1.584 0l-.043.044Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "url(#b)",
        d: "M16.173 21.16a10.03 10.03 0 0 1-4.174.904C6.441 22.064 1.936 17.558 1.936 12S6.44 1.937 11.999 1.937c5.558 0 10.064 4.505 10.064 10.063a10.02 10.02 0 0 1-2.245 6.336 1.01 1.01 0 0 0-.033-.035l-2.902-2.902c-.02-.02-.04-.04-.062-.057a5.867 5.867 0 1 0-3.988 2.468l3.34 3.35Z",
        opacity: 0.3
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M11.994 15.752a3.75 3.75 0 1 0 .001-7.498 3.75 3.75 0 0 0-.001 7.498Zm3.262-.309a1.119 1.119 0 0 0 0 1.583l2.902 2.902a1.12 1.12 0 0 0 1.583 0l.043-.044a1.12 1.12 0 0 0 0-1.583L16.883 15.4a1.119 1.119 0 0 0-1.583 0l-.044.044Z"
      }
    ),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "b", x1: 12.814, x2: 17.868, y1: 13.226, y2: 10.272, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "currentColor", stopOpacity: 0 })))
  );
};
export default Explore;
